module.exports = __webpack_public_path__ + "static/img/background.e1f33953.png";